<template>
  <DarkMatterLogo v-if="isDarkMatterBrand" />
  <div
    v-else
    class="flex items-center"
  >
    <img
      v-if="logoUrl"
      :src="logoUrl"
      :alt="brandName + ' Logo'"
      class="h-8 w-8 mr-2"
    >
    <img
      v-else
      src="@/assets/quantm-alpha-logo-small.png"
      :alt="brandName + ' Logo'"
      class="h-8 w-8 mr-2"
    >
    <img
      v-if="wordmarkUrl"
      :src="wordmarkUrl"
      :alt="brandName"
      class="h-5"
    >
    <span
      v-else
      class="text-xl font-oxygen"
    >{{ brandName }}</span>
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";
import DarkMatterLogo from "@/components/DarkMatterLogo.vue";

export default {
  name: "BrandComponent",
  components: { DarkMatterLogo },
  setup() {
    const store = useStore();
    const brandName = computed(() => store.getters["brand/brandName"]);
    const brandSlug = computed(() => store.getters["brand/brandSlug"]);
    const logoUrl = computed(() => store.getters["brand/logoUrl"]);
    const wordmarkUrl = computed(() => store.getters["brand/wordmarkUrl"]);
    const isDarkMatterBrand = computed(() => brandSlug.value === "dark-matter");

    return { brandName, logoUrl, wordmarkUrl, isDarkMatterBrand };
  },
};
</script>

<style scoped>
@font-face {
  font-family: "Oxygen";
  src: url("@/assets/fonts/Oxygen-Regular.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}

.font-oxygen {
  font-family: "Oxygen", sans-serif;
}
</style>
